import React from 'react';
import {Col, Container, Row, Button} from 'reactstrap';

import PageMeta from 'components/PageMeta';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import Footer from 'components/Elements/Footer';
import Header from 'components/Elements/Header';

export default function CallsIndex() {
  const pageTitle = 'Learn More';
  const pageDescription =
    'Combine in-depth plant-based nutrition education, results-driven coaching skills, and practical training to help you create greater impact and income while making a meaningful difference in the world.';
  const ogImage =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const shareUrl = 'https://certificate.foodrevolution.org/join/';
  const facebookDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const twitterImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const pinterestDescription =
    'Join Food Revolution Network’s Plant-Based Coaching Certificate Program to empower others with evidence-based nutrition and coaching skills.';
  const pinterestImg =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-pin.png';

  return (
    <div className="page d-flex flex-column page-nosocial">
      <PageMeta title={pageTitle} description={pageDescription} url={shareUrl} ogImage={ogImage} />
      <div className="page-content">
        <Header
          bgColor="black"
          lockupWhite
          logoUrlOverride="https://cdn.foodrevolution.org/pbcc/pbcc-certificate-logo-white.svg"
          logoAltOverride="plant-based coaching logo"
          logoWidthOverride={300}
          logoHeightOverride={59}
          shareUrl={shareUrl}
          shareImg={ogImage}
          facebookDescription={facebookDescription}
          twitterDescription={twitterDescription}
          pinterestDescription={pinterestDescription}
          pinterestImage={pinterestImg}
        />
        <SectionCL id="pbcc-clarity-header" color="dark-gray" className="text-center" angle="none" order="first">
          <Container>
            <Row>
              <Col>
                <div className="background-light-gray rounded box-shadow-black-50 p-4 p-lg-5">
                  <h1 className="section-heading mb-3">Book Your Free Clarity Call</h1>
                  <h3 className="mt-0 mb-3">
                    Thank you for wanting to learn more about the <br className="d-none d-xl-block" />
                    Plant-Based Coaching Certificate before signing up!
                  </h3>
                  <p className="text-h5 mb-0">
                    In order for us to direct you to the right person, <br className="d-none d-xl-block" />
                    <b>please select an option below</b> that best fits your needs.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
        <SectionCL id="" color="light-gray" angle="top" innerClass="pt-4" order="last">
          <Container>
            <Row className="align-items-stretch">
              <Col lg="6" className="d-flex flex-column mb-5">
                <Button
                  color="call"
                  className="d-flex flex-column flex-grow-1"
                  href="/clarity-calls/"
                  target="_blank"
                  block
                >
                  <div className="background-white box-shadow-black-50 rounded d-flex flex-column flex-grow-1">
                    <div className="p-4">
                      <h5 className="section-heading text-center">
                        Interested in enrolling and have questions about the program?
                      </h5>
                      <p className="mb-0">
                        <i>
                          <b>Please note:</b> Program Advisors are not able to answer questions or provide any
                          information about scholarships.
                        </i>
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="btn btn-cta btn-call-cta">Click here to speak with a Program Advisor</div>
                    </div>
                  </div>
                </Button>
              </Col>
              <Col lg="6" className="d-flex flex-column mb-5">
                <Button
                  color="call"
                  className="d-flex flex-column flex-grow-1"
                  href="/office-hours/"
                  target="_blank"
                  block
                >
                  <div className="background-white box-shadow-black-50 rounded d-flex flex-column flex-grow-1">
                    <div className="p-4">
                      <h5 className="section-heading text-center">
                        Already enrolled as a student, <br className="d-none d-xl-block" />
                        but have questions?
                      </h5>
                      <p className="text-left mb-0">
                        Enrolled means you’ve made at least one tuition payment. A deposit alone does not count as
                        enrollment.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="btn btn-cta btn-call-cta">
                        Click here to speak with the PBCC Student Support Team
                      </div>
                    </div>
                  </div>
                </Button>
              </Col>
              <Col lg="6" className="d-flex flex-column mb-5 mb-lg-0">
                <Button
                  color="call"
                  className="d-flex flex-column flex-grow-1"
                  href="/graduate-calls/"
                  target="_blank"
                  block
                >
                  <div className="background-white box-shadow-black-50 rounded d-flex flex-column flex-grow-1">
                    <div className="p-4">
                      <h5 className="section-heading text-center">
                        Interested in enrolling and want <br className="d-none d-xl-block" />
                        to speak with a graduate?
                      </h5>
                      <p className="mb-0">
                        Hear firsthand how the Certificate changed their life and what to expect in the program.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="btn btn-cta btn-call-cta">Click here to speak with a Student Ambassador</div>
                    </div>
                  </div>
                </Button>
              </Col>
              <Col lg="6" className="d-flex flex-column mb-5 mb-lg-0">
                <Button
                  color="call"
                  className="d-flex flex-column flex-grow-1"
                  href="https://cdn.foodrevolution.org/members/pdf/pbcc/Plant-Based%20Coaching%20Certificate%20-%20Scholarship%20Guide.pdf"
                  target="_blank"
                  block
                >
                  <div className="background-white box-shadow-black-50 rounded d-flex flex-column flex-grow-1">
                    <div className="p-4">
                      <h5 className="section-heading text-center">
                        Need financial support <br className="d-none d-xl-block" />
                        to make this possible?
                      </h5>
                      <p>Please view the following Scholarship Guide before connecting with our team.</p>
                      <p className="mb-0">
                        Contact us at{' '}
                        <a href="mailto:certification@foodrevolution.org" target="_blank">
                          certification@foodrevolution.org
                        </a>{' '}
                        for any further questions.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div className="btn btn-cta btn-call-cta">Click here to download our Scholarship Guide</div>
                    </div>
                  </div>
                </Button>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>
      <div className="footer-content mt-auto">
        <Footer />
      </div>
    </div>
  );
}
